module.exports = __webpack_public_path__ + "img/down-arrow.b33570b8.svg";